import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { MainComponent } from './layout/main.component';
import { AppComponent } from './app.component';
import { MatIconRegistry } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { appRoutes } from './app.route';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from '../shared/auth/auth.interceptor';
import { ProductsComponent } from './products/ad-tags/products.component';
import { PublisherRequestSummaryComponent } from './products/ad-tags/publisher-request-summary.component';
import { WidgetTypePreviewDialogComponent } from './products/ad-tags/widget-type-preview-dialog.component';
import { PublisherRequestNewDomainDialogComponent } from './products/ad-tags/publisher-request-new-domain-dialog.component';
import { PublisherRequestSuccessComponent } from './products/ad-tags/publisher-request-success.component';
import { CmSharedModule } from '../shared/shared-module';
import { Principal } from '../shared/auth/principal.service';
import { PublisherResolver } from './publisher.resolver';
import { PublisherStatsService } from './shared/services/publishers-stats.service';
import { ProductsBidderComponent } from './products/bidder/products-bidder.component';
import { ProductsBidderSummaryComponent } from './products/bidder/products-bidder-summary.component';
import { PublisherLoginComponent } from './login/publisher-login.component';
import { SelfServedWelcomeGuard } from './self-served-welcome.guard';
import { TipaltiPayableGuard } from './tipalti-payable.guard';
import { AuthModule } from '../shared/auth-module';
import { PubBlockRequestService } from '../shared/services/pub-block-request.service';
import { PbAdsTxtRecordsComponent } from './ads-txt/pb-ads-txt-records.component';
import { ApiComponent } from './api/api.component';
import { AdTagConfirmDialogComponent } from './products/ad-tags/ad-tag-confirm-dialog.component';
import {PublisherAppImportUploadDialog} from './sites/publisher-app-import-upload-dialog.component';
import { PromocastComponent } from './products/promocast/promocast.component';
import {PublisherDashboardService} from './dashboard/publisher-dashboard.service';
import {PodcastClipEditDialogComponent} from './products/promocast/podcast-clip-edit-dialog.component';
import {RssStatusCircleComponent} from './products/promocast/RssStatusCircleComponent';


@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    ProductsComponent,
    WidgetTypePreviewDialogComponent,
    PublisherLoginComponent,
    PublisherRequestSummaryComponent,
    PublisherRequestNewDomainDialogComponent,
    PublisherRequestSuccessComponent,
    PublisherAppImportUploadDialog,
    AdTagConfirmDialogComponent,
    PbAdsTxtRecordsComponent,
    ProductsBidderComponent,
    ProductsBidderSummaryComponent,
    PublisherAppImportUploadDialog,
    ApiComponent,
    PromocastComponent,
    PodcastClipEditDialogComponent,
    RssStatusCircleComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CmSharedModule,
    FormsModule,
    AuthModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatStepperModule,
    RouterModule.forRoot(
      appRoutes,
      {
        useHash: true,
        // enableTracing: true  // <-- debugging purposes only
      }
    )
  ],
  providers: [
    MatIconRegistry,
    Principal,
    SelfServedWelcomeGuard,
    TipaltiPayableGuard,
    PublisherResolver,
    PublisherStatsService,
    PubBlockRequestService,
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    PercentPipe,
    PublisherDashboardService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  entryComponents: [
    WidgetTypePreviewDialogComponent,
    PublisherRequestNewDomainDialogComponent,
    AdTagConfirmDialogComponent,
    PublisherAppImportUploadDialog,
    PodcastClipEditDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
